import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Reveal } from "@/components/site/Reveal";
import { ShieldAlert, CheckCircle2, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AccountDeletion() {
  const [form, setForm] = useState({ name: "", email: "", username: "", reason: "" });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/account-deletion", form);
      setResult(data);
      toast.success("Talebiniz alındı.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="bg-[#0A1A10] sr-grain pt-36 pb-16">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#D4AF37]/30 bg-white/5">
            <ShieldAlert className="h-4 w-4 text-[#D4AF37]" />
            <span className="font-mono-accent text-xs uppercase tracking-widest text-white/80">Google Play Uyumlu</span>
          </span>
          <h1 className="font-serif-display text-white text-4xl sm:text-5xl font-bold mt-5">Hesap Silme Talebi</h1>
          <p className="text-white/60 mt-4">
            Saklı Rota hesabınızı ve ilişkili verilerinizi silmek için aşağıdaki formu doldurun. Talebiniz incelenerek
            en geç 30 gün içinde işleme alınacaktır.
          </p>
        </div>
      </section>

      <section className="bg-[#F8F9FA] py-16 sm:py-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          {result ? (
            <Reveal>
              <div data-testid="deletion-success" className="rounded-3xl bg-white border border-[#E2E8E4] p-10 text-center">
                <CheckCircle2 className="h-14 w-14 text-[#40916C] mx-auto" />
                <h3 className="font-serif-display text-2xl font-semibold text-[#1A251E] mt-5">Talebiniz Alındı</h3>
                <p className="text-[#5C6F62] mt-2">Hesap silme talebiniz başarıyla oluşturuldu.</p>
                <div className="mt-6 inline-block rounded-2xl bg-[#F8F9FA] border border-[#E2E8E4] px-6 py-4">
                  <p className="font-mono-accent text-xs uppercase tracking-wider text-[#5C6F62]">Talep Takip Numarası</p>
                  <p className="font-mono-accent text-2xl font-bold text-[#0F2F1D] mt-1" data-testid="deletion-ticket">{result.ticket}</p>
                </div>
                <p className="text-sm text-[#5C6F62] mt-6">Bu numarayı saklayın. Talebinizin durumu için bu numara ile bize ulaşabilirsiniz.</p>
              </div>
            </Reveal>
          ) : (
            <form onSubmit={submit} data-testid="account-deletion-form" className="rounded-3xl bg-white border border-[#E2E8E4] p-8 space-y-5">
              <div className="flex items-center gap-3 rounded-2xl bg-[#FDF6E3] border border-[#D4AF37]/30 px-5 py-4 text-sm text-[#7a5c00]">
                <Trash2 className="h-5 w-5 shrink-0" />
                <span>Hesabınız silindiğinde tüm rotalarınız, favorileriniz ve anılarınız kalıcı olarak kaldırılır.</span>
              </div>
              <label className="block">
                <span className="block text-sm font-medium text-[#1A251E] mb-2">Ad Soyad <span className="text-red-500">*</span></span>
                <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="deletion-name-input" className="sr-input" placeholder="Adınız Soyadınız" />
              </label>
              <label className="block">
                <span className="block text-sm font-medium text-[#1A251E] mb-2">E-posta <span className="text-red-500">*</span></span>
                <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="deletion-email-input" className="sr-input" placeholder="ornek@eposta.com" />
              </label>
              <label className="block">
                <span className="block text-sm font-medium text-[#1A251E] mb-2">Kullanıcı Adı <span className="text-[#5C6F62] font-normal">(opsiyonel)</span></span>
                <input value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} data-testid="deletion-username-input" className="sr-input" placeholder="Uygulamadaki kullanıcı adınız" />
              </label>
              <label className="block">
                <span className="block text-sm font-medium text-[#1A251E] mb-2">Açıklama <span className="text-[#5C6F62] font-normal">(opsiyonel)</span></span>
                <textarea rows={4} value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} data-testid="deletion-reason-input" className="sr-input resize-none" placeholder="Silme nedeninizi belirtebilirsiniz..." />
              </label>
              <button disabled={loading} data-testid="deletion-submit-btn" className="w-full px-6 py-4 rounded-full bg-[#0F2F1D] text-white font-semibold hover:bg-[#1B4D2E] transition-colors disabled:opacity-60">
                {loading ? "Gönderiliyor..." : "Silme Talebi Gönder"}
              </button>
            </form>
          )}
        </div>
      </section>
    </>
  );
}
